import { AxiosError, AxiosResponse } from 'axios';
import { extractFileNameFromHeader, triggerDownload } from '@utils/fileDownloadUtil';
import { api } from 'agent';
import { DownloadedFileDTO } from './dto/DownloadedFileDTO';

export default function postFiles(files: File[]): Promise<void> {
  const formData = new FormData();
  files.forEach(file => {
    formData.append('files', file);
  });
  return api.post(`file/upload/`, formData);
}

function downloadFileCommon(endpoint: string) {
  return (
    // eslint-disable-next-line no-underscore-dangle
    api
      // eslint-disable-next-line no-underscore-dangle
      ._safeQuery(api._axios.get, endpoint, null, null, false, false, {
        responseType: 'arraybuffer',
      })
      .then((response: { data: File; headers: any }) => {
        const fileName = extractFileNameFromHeader(response as AxiosResponse);
        triggerDownload(response as AxiosResponse, fileName);
        return { data: response.data, fileName };
      })
      .catch((error: AxiosError) => {
        const enc = new TextDecoder('utf-8');
        const err = error as AxiosError;
        throw new Error(enc.decode(err.response?.data as BufferSource));
      })
  );
}

export function downloadFile(id: number, zip?: boolean): Promise<DownloadedFileDTO> {
  return zip
    ? downloadFileCommon(`file/download/zip/${id}`)
    : downloadFileCommon(`file/download/${id}`);
}
